import { QueryParams } from '../../../shared/types/Common';
import {
  ICaseAssociationModel,
  ICaseInfo,
  ICaseStage,
  ICaseStageResponse,
  ICaseSubproject,
  IGovernmentCaseNumber,
} from '../../../shared/types/Case';
import { createApiFetcher } from 'src/utils/ApiUtils';
import { DocumentData, DocumentResponse } from 'src/shared/types/Document';
import { DocumentsAxiosInstance } from '../axios/axios';
import { IChecklistItem, IChecklistItemGroup } from 'src/shared/types/Documents';

const fetchData = createApiFetcher('case/');

export const getCaseList = (beneId: number, groupSubProjectsByParent: boolean): Promise<ICaseAssociationModel[]> =>
  fetchData<ICaseAssociationModel[]>('list', { beneId, groupSubProjectsByParent });

export const getActiveCases = (params?: QueryParams): Promise<ICaseInfo[]> =>
  fetchData<ICaseInfo[]>('active-case-list', params);

export const getCaseDetails = (caseId: number): Promise<ICaseInfo> => fetchData<ICaseInfo>(`${caseId}`);

export const getCaseStage = (caseId: number): Promise<ICaseStageResponse> =>
  fetchData<ICaseStageResponse>(`stage/${caseId}`);

export const getGovernmentCaseNumbers = (caseId: number): Promise<IGovernmentCaseNumber[]> =>
  fetchData<IGovernmentCaseNumber[]>('government-case-numbers', { caseId });

export const getCaseHighLevelStatus = (caseId: number): Promise<ICaseStage[]> =>
  fetchData<ICaseStage[]>('high-level-status', { caseId });

export const getCaseSubprojects = (caseId: number): Promise<ICaseSubproject[]> =>
  fetchData<ICaseSubproject[]>('subprojects', { caseId });
``;

export const getDocumentTypes = async (): Promise<DocumentData[]> => fetchData<DocumentData[]>('document-types');

export const getDocument = async (docId: string): Promise<DocumentData> =>
  fetchData<DocumentData>('documents', { docId });

export const getCaseChecklist = async (caseId: number): Promise<IChecklistItem[]> => {
  const data = await DocumentsAxiosInstance.get(`casechecklist?caseId=${caseId}`);

  return data.data;
};

export const createChecklistItemGroup = async (checklistItemId: number): Promise<IChecklistItemGroup> => {
  const data = await DocumentsAxiosInstance.post(`casechecklistitemgroup?checklistItemId=${checklistItemId}`);

  return data.data;
};

export const getCaseDocument = async (beneId: number, caseId: number): Promise<DocumentResponse[]> =>
  fetchData<DocumentResponse[]>(`documents/${beneId}`, { caseId });
